import { ACTIONS_MINE_PLAN } from '_constants/mineplan.constants';

const initialState = {
  byId: {},
};

export function minePlanReducer(state = initialState, action) {
  switch (action.type) {
    case ACTIONS_MINE_PLAN.INVALIDATE: {
      return {
        ...initialState,
      };
    }

    case ACTIONS_MINE_PLAN.DELETE: {
      const currentById = { ...state.byId };
      delete currentById[Object.keys(action.byId)[0]];

      return {
        ...state,
        byId: currentById,
      };
    }

    case ACTIONS_MINE_PLAN.RECEIVE: {
      return {
        ...state,
        byId: { ...state.byId, ...action.byId },
      };
    }

    default:
      return state;
  }
}

export default minePlanReducer;
